import { api, generateQueryParamFromObj, prefix } from "@/api";
import { AxiosHeaders, type AxiosRequestConfig } from "axios";
import { serialize } from "object-to-formdata";
import type { userType } from "@/types/user";
import { layerType } from "@/types/api";
import { networkType } from "@/types/network";
import { initType } from "@/types/application";

const namespace = "profile";

export const init = (config: AxiosRequestConfig = {}) => {
  return api<initType>({
    url: `${prefix}/mango/init`,
    method: "get",
    ...config,
  });
};

export const getDetails = (
  params: { withIdentity: boolean; id?: number } = { withIdentity: false },
  config: AxiosRequestConfig = {}
) => {
  return api<userType>({
    url: `${prefix}/${namespace}/profile${params.id ? `/${params.id}` : ""}?withIdentity=${params.withIdentity}`,
    method: "GET",
    ...config,
  });
};

export const getRoles = (
  config: AxiosRequestConfig = {}
): Promise<
  Array<{
    applicationId: number;
    roleId: number;
    roleName: string;
    userId: string;
  }>
> => {
  return api({
    url: `${prefix}/${namespace}/profile/roles`,
    method: "get",
    ...config,
  });
};

export const getNetwork = (config: AxiosRequestConfig = {}) => {
  return api<any>({
    url: `${prefix}/${namespace}/v2/network`,
    method: "get",
    ...config,
  });
};

export const login = (config: AxiosRequestConfig = {}): Promise<void> => {
  return api({
    url: `${prefix}/${namespace}/login`,
    method: "POST",
    ...config,
  });
};

export const updateAvatar = (image: File): Promise<void> => {
  const headers = new AxiosHeaders({ "Content-Type": "multipart/form-data" });
  return api({
    url: `${prefix}/${namespace}/profile/avatar`,
    method: "post",
    data: serialize({ image: image }),
    headers: headers,
  });
};

export const updateUser = (
  params: Partial<userType>,
  config: AxiosRequestConfig = {}
): Promise<{ id: string }> => {
  return api({
    url: `${prefix}/${namespace}/profile`,
    method: "put",
    data: params,
    ...config,
  });
};

export const getLoggedUserNetworks = (config: AxiosRequestConfig = {}) => {
  return api<layerType<networkType>>({
    url: `${prefix}/mango/networks`,
    method: "get",
    ...config,
  });
};

export const getUsersList = ( 
  params?: {
    projections?: string;
    limit?: number;
    page?: number;
    status?: string;
    searchText?: string;
    role_ids?: string;
  }, 
  config: AxiosRequestConfig = {}
) => {
  let query;
  if( params ){
    query = generateQueryParamFromObj(params);
  }
  return api<layerType<userType>>({
    url: `${prefix}/mango/users?${query ?? ""}`,
    method: "get",
    ...config,
  });
};

